<script>
  import http from '@/service/http'
  import findIndex from 'lodash/findIndex'
  import isEmpty from 'lodash/isEmpty'
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'

  moment.locale('pt-br')
  export default {
    name: 'Orcamentos',
    data () {
      return {
        list: [],
        modal: [],
        busca: '',
        ordenar: 'id',
        pagination: {
          current_page: 1,
          last_page: 1
        }
      }
    },
    mounted () {
      const {status} = this.$route.params
      if (status !== undefined) {
        this.busca = status
      }
      this.paginate()
    },
    methods: {
      async paginate (page) {
        if (page) {
          this.pagination.current_page = page
        }
        const {data} = await http.get(`/orcamentos?page=${this.pagination.current_page}&busca=${this.busca}&order=${this.ordenar}`)
        if (data != null) {
          this.list = data.data
          this.pagination.current_page = data.current_page
          this.pagination.last_page = data.last_page
        }
      },
      async buscar ($page) {
        const {data} = await http.get(`/orcamentos?&busca=${this.busca}&order=${this.ordenar}`)
        if (data != null) {
          this.list = data.data
          this.pagination.current_page = data.current_page
          this.pagination.last_page = data.last_page
        }
      },
      checkListTotal () {
        if (this.list.length === 0) {
          this.pagination.current_page = 1
          this.busca = ''
          this.paginate()
        }
      },
      async updateList (obj) {
        const {orcamento} = obj
        const index = await findIndex(this.list, {id: orcamento.id})
        if (index > -1) {
          this.list[index] = {...orcamento}
        } else {
          this.list.unshift(orcamento)
        }
        window.Materialize.toast('Registro salvo com sucesso!!', 4000)
      },
      destroy (orcamento) {
        this.$swal({
          title: `Deseja remover ${orcamento.nome}?`,
          html: 'Esta operação é irreversível',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(async () => {
          const {data} = await http.delete(`/orcamentos/${orcamento.id}`)
          if (data != null) {
            const index = await findIndex(this.list, {id: orcamento.id})
            if (index > -1) {
              this.list.splice(index, 1)
              window.Materialize.toast('Registro removido com sucesso!!', 4000)
              this.checkListTotal()
            }
          }
        })
      },
      formatDate (date) {
        return moment(date).format('DD/MM HH:mm')
      },
      formatDateFrom (date) {
        return moment(date).fromNow()
      },
      modalProposta (propostas, proposta) {
        if (!isEmpty(propostas)) {
          this.modal = propostas
        }
        if (!isEmpty(proposta)) {
          this.modal = proposta
        }
        if (!isEmpty(this.modal)) {
          $('#modalProposta').modal('open')
        }
      }
    },
    computed: {
      ...mapState(['loading']),
      ...mapGetters(['permissoes']),
      showBtNovo () {
        return this.$route.name === 'orcamentos.index'
      },
      showBtVoltar () {
        return this.$route.name === 'orcamentos.form'
      },
      hasItens () {
        return this.list.length > 0
      },
      api_url () {
        return process.env.API_URL
      }
    }
  }
</script>

<template>
  <div>

    <div class="content">
      <form @submit.prevent="buscar" v-show="showBtNovo">
      <div class="row">
        <div class="col s12 m6">
          <h5>Orçamentos</h5>
        </div>
        <div class="input-field col s3 m2">
          <select id="ordenar" v-model="ordenar" @change="buscar">
            <option value="id">Ordenar por Data</option>
            <option value="valor">Ordenar por Valor</option>
          </select>
        </div>
        <div class="input-field col s6 m3">
            <input id="busca" type="text" v-model="busca">
            <label for="busca">Buscar</label>
        </div>
        <div class="col s3 m1 input-field right-align">
          <router-link :to="{ name: 'orcamentos.form' }"
                       v-show="showBtNovo && permissoes.indexOf('orcamento.inserir') > -1"
                       class="btn-floating btn-large waves-effect waves-light"><i class="material-icons">add</i>
          </router-link>
          <router-link :to="{ name: 'orcamentos.index' }" v-show="showBtVoltar"
                       class="btn-floating btn-large waves-effect waves-light red"><i class="material-icons">close</i>
          </router-link>
        </div>
      </div>
      </form>

      <div class="row">
        <div class="col s12">
          <router-view @update-orcamentos-list="updateList"></router-view>
        </div>
      </div>

      <div class="center-align" v-show="showBtNovo && !hasItens && !loading">
        <p>Nenhum registro encontrado!</p>
      </div>

      <div class="row z-depth-1" v-show="showBtNovo && hasItens">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
            <tr>
              <th>#</th>
              <th>Data</th>
              <th>Responsável</th>
              <th>Contatos</th>
              <th>Lido</th>
              <th>Propostas</th>
              <th>Status</th>
              <th class="right-align">Ações</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="orcamento in list" :class="{ 'green lighten-2': orcamento.status_id === 5, 'red lighten-2': orcamento.status_id === 6, 'amber lighten-1 black-text': orcamento.status_id === 4, 'amber lighten-1 black-text': orcamento.status_id === 1,  'blue lighten-2': orcamento.status_id === 2, 'amber lighten-1 black-text': orcamento.status_id === 3 }">
              <td>
                <router-link :to="{ name: 'orcamentos.form', params: { id: orcamento.id } }"
                             v-if="permissoes.indexOf('orcamento.editar') > -1">{{ orcamento.id }}
                </router-link>
                <span v-else>{{ orcamento.id }}</span>
              </td>
              <td>
                {{ formatDate(orcamento.created_at) }}
                <small><br/>{{ formatDateFrom(orcamento.created_at) }}</small>
              </td>
              <td>
                <router-link :to="{ name: 'orcamentos.form', params: { id: orcamento.id } }"
                             v-if="permissoes.indexOf('orcamento.editar') > -1">{{ orcamento.responsavel }}
                </router-link>
                <span v-else>{{ orcamento.responsavel }}</span>
                <small v-if="orcamento.razao_social"><br/>{{ orcamento.razao_social }}</small>
              </td>
              <td>
                {{ orcamento.telefone }}<br/>
                <small>
                  {{ orcamento.telefone2 ? orcamento.telefone2 : '' }}
                  {{ orcamento.telefone3 ? ', '+orcamento.telefone3 : '' }}
                </small>
                <br/>
                <small>{{ orcamento.email }}</small>
                <br>
                <small>{{ orcamento.localizacao_mapa }}</small>
              </td>
              <td>
                {{ orcamento.leitura ? formatDate(orcamento.leitura) : '-' }}
              </td>
              <td>
                <select>
                  <option v-for="proposta in orcamento.propostas">{{ proposta.valor_total }}</option>
                </select>
              </td>
              <td>{{ (orcamento.status) ? orcamento.status.status : '-' }}</td>
              <td class="right-align">
                <a href="#" class="tooltipped" data-label="Abrir" data-position="left" data-delay="50"
                   data-tooltip="Detalhes" @click.prevent="modalProposta(orcamento.propostas, orcamento.proposta)"><i
                  class="material-icons blue-text">search</i></a>
                <a :href="`${api_url}/orcamento/${orcamento.id}/pdf`" class="material-icons green-text" target="_blank"><i
                  class="material-icons">file_download</i></a>
                <router-link :to="{ name: 'orcamentos.form', params: { id: orcamento.id } }"
                             v-show="permissoes.indexOf('orcamento.editar') > -1"><i class="material-icons blue-text">edit</i>
                </router-link>
                <a href="#" @click.prevent="destroy(orcamento)" v-show="permissoes.indexOf('orcamento.excluir') > -1">
                  <i class="material-icons red-text">delete_forever</i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-show="showBtNovo && hasItens">
        <div class="col s12 center-align">
          <paginate
            :page-count='pagination.last_page'
            :click-handler="paginate"
            :prev-text="'chevron_left'"
            :next-text="'chevron_right'"
            :container-class="'pagination'"
            :page-class="'waves-effect'"
            :prev-class="'material-icons'"
            :next-class="'material-icons'"
            :force-page='pagination.current_page-1'
          >
          </paginate>
        </div>
      </div>

    </div>
    <div id="modalProposta" class="modal">
      <div class="modal-content">
        <h4><span v-if="Array.isArray(modal)">Propostas</span><span v-else>Proposta Aprovada</span></h4>
        <div class="propostas" v-if="Array.isArray(modal)">
          <div class="row z-depth-1" v-for="(proposta, indexProposta) in modal">

            <div class="col s12">

              <div class="row" v-show="proposta.servicos && proposta.servicos.length > 0">
                <div class="col s12">
                  <table class="responsive-table bordered highlight">
                    <tr>
                      <th>Serviços da Proposta</th>
                      <th>Qtd</th>
                      <th>Valor</th>
                      <th>Valor Total</th>
                    </tr>
                    <tr v-for="(servico, indexServico) in proposta.servicos">
                      <td>
                        <p>{{ (servico.servico) ? servico.servico.servico : '-' }}</p>
                      </td>
                      <td>
                        <input disabled  type="number" :id="`qtdServico${indexServico}`" v-model="servico.qtd" min="1" style="margin-bottom: 0">
                      </td>
                      <td>
                        <input disabled type="number" :id="`valorServico${indexServico}`" v-model="servico.valor" min="1" style="margin-bottom: 0">
                      </td>
                      <td>
                        <input disabled type="number" :id="`valorTotalServico${indexServico}`" :value="servico.valor * servico.qtd" style="margin-bottom: 0" readonly>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

            </div>

          </div>
        </div>
        <div class="proposta" v-else>
          <div class="row z-depth-1">
            <div class="col s12">
              <div class="row" v-show="modal.servicos && modal.servicos.length > 0">
                <div class="col s12">
                  <table class="responsive-table bordered highlight">
                    <tr>
                      <th>Serviços da Proposta</th>
                      <th>Qtd</th>
                      <th>Valor</th>
                      <th>Valor Total</th>
                    </tr>
                    <tr v-for="(servico, indexServico) in modal.servicos">
                      <td>
                        <p>{{ (servico.servico) ? servico.servico.servico : '-' }}</p>
                      </td>
                      <td>
                        <input disabled  type="number" :id="`qtdServico${indexServico}`" v-model="servico.qtd" min="1" style="margin-bottom: 0">
                      </td>
                      <td>
                        <input disabled type="number" :id="`valorServico${indexServico}`" v-model="servico.valor" min="1" style="margin-bottom: 0">
                      </td>
                      <td>
                        <input disabled type="number" :id="`valorTotalServico${indexServico}`" :value="servico.valor * servico.qtd" style="margin-bottom: 0" readonly>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/features/orcamentos/orcamentos/index.vue